import React from "react";
import { StarIcon } from "@heroicons/react/24/solid";

interface GoogleReviewsDisplayProps {
  title?: string;
  subtitle?: string;
  maxReviews?: number;
  accentColor?: string;
}

const GoogleReviewsDisplay: React.FC<GoogleReviewsDisplayProps> = ({
  title = "What Our Students Say",
  subtitle = "Real reviews from Google",
  maxReviews = 6,
  accentColor = "#f5694b",
}) => {
  // Actual Nomadroof Experiences reviews from Google (Updated)
  const staticReviews = [
    {
      author_name: "Amelie Holst",
      author_url: "https://maps.app.goo.gl/N5My64AdjBBPGKXq7",
      profile_photo_url: "https://ui-avatars.com/api/?name=Amelie+Holst&background=4285F4&color=fff",
      rating: 5,
      relative_time_description: "8 hours ago",
      text: "I had the best time staying with Nomadroof! (Casa Yumbilla). The organized parties and trips have made my exchange unforgettable. Especially Semana Santa in Ayacucho was a time full of laughters and amazing memories!! I can only recommend staying with Nomadroof if you want to meet the nicest people and have the best time!",
      time: Date.now(),
    },
    {
      author_name: "Roxane Morter",
      author_url: "https://maps.app.goo.gl/N5My64AdjBBPGKXq7",
      profile_photo_url: "https://ui-avatars.com/api/?name=Roxane+Morter&background=EA4335&color=fff",
      rating: 5,
      relative_time_description: "15 hours ago",
      text: "Without Nomadroof, this exchange would not have been the same. The parties, the trips, the connections, it made everything so effortless and special. Thank you :)",
      time: Date.now(),
    },
    {
      author_name: "Hiva Moezi",
      author_url: "https://maps.app.goo.gl/N5My64AdjBBPGKXq7",
      profile_photo_url: "https://ui-avatars.com/api/?name=Hiva+Moezi&background=FBBC04&color=fff",
      rating: 5,
      relative_time_description: "a day ago",
      text: "I had the best time at Casa Madrid! I really felt comfortable, all the staff very really helpful and organized a lot of fun parties and trips. I truly felt like at home 💓",
      time: Date.now(),
    },
    {
      author_name: "Timm Seikel",
      author_url: "https://maps.app.goo.gl/N5My64AdjBBPGKXq7",
      profile_photo_url: "https://ui-avatars.com/api/?name=Timm+Seikel&background=34A853&color=fff",
      rating: 5,
      relative_time_description: "a day ago",
      text: "Good parties, good trips and good vibes! Thanks for the amazing time. See ya 🤙",
      time: Date.now(),
    },
    {
      author_name: "Vivien K",
      author_url: "https://maps.app.goo.gl/N5My64AdjBBPGKXq7",
      profile_photo_url: "https://ui-avatars.com/api/?name=Vivien+K&background=4285F4&color=fff",
      rating: 5,
      relative_time_description: "2 days ago",
      text: "Without Nomadroof, the whole exchange wouldn't have been the same. Nomadroof created such a wonderful community where it was easy to meet new friends and create incredible memories. The staff was super super helpful in every situation and the trips were perfectly organized. Thanks for being a home away from home for me🫶🏽",
      time: Date.now(),
    },
    {
      author_name: "Victor David",
      author_url: "https://maps.app.goo.gl/N5My64AdjBBPGKXq7",
      profile_photo_url: "https://ui-avatars.com/api/?name=Victor+David&background=EA4335&color=fff",
      rating: 5,
      relative_time_description: "3 days ago",
      text: "The whole nomadroof team is insane ! What an experience we lived there in Peru thanks to them, I recommend !",
      time: Date.now(),
    },
    {
      author_name: "Fabienne De Fouw",
      author_url: "https://maps.app.goo.gl/N5My64AdjBBPGKXq7",
      profile_photo_url: "https://ui-avatars.com/api/?name=Fabienne+De+Fouw&background=FBBC04&color=fff",
      rating: 5,
      relative_time_description: "a week ago",
      text: "Always a good time and very fun experiences!",
      time: Date.now(),
    },
    {
      author_name: "Tom Goarin",
      author_url: "https://maps.app.goo.gl/N5My64AdjBBPGKXq7",
      profile_photo_url: "https://ui-avatars.com/api/?name=Tom+Goarin&background=34A853&color=fff",
      rating: 5,
      relative_time_description: "a week ago",
      text: "I had a great time with nomadroof, living in one of their 'casas' was a trully fullfilling experience, a lot of fun and a way to create great friendships. Also, they propose some trips in Peru throughout the semester, which is a great way to discover the country.",
      time: Date.now(),
    },
    {
      author_name: "Ruben den Boer",
      author_url: "https://maps.app.goo.gl/N5My64AdjBBPGKXq7",
      profile_photo_url: "https://ui-avatars.com/api/?name=Ruben+den+Boer&background=4285F4&color=fff",
      rating: 5,
      relative_time_description: "a month ago",
      text: "The organised trips and parties were amazing. Nomadroof made my exchange one to never forget!",
      time: Date.now(),
    },
    {
      author_name: "Shirin Fasbender",
      author_url: "https://maps.app.goo.gl/N5My64AdjBBPGKXq7",
      profile_photo_url: "https://ui-avatars.com/api/?name=Shirin+Fasbender&background=EA4335&color=fff",
      rating: 5,
      relative_time_description: "a month ago",
      text: "I had the most amazing time in Casa Madrid! Wouldn't go ANYWHERE else for my exchange!",
      time: Date.now(),
    },
  ];

  const averageRating = 5.0;
  const totalReviews = 10;

  const renderStars = (rating: number, size: "small" | "large" = "small") => {
    const starSize = size === "large" ? "w-6 h-6" : "w-5 h-5";
    
    return (
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <StarIcon
            key={star}
            className={`${starSize} ${
              star <= rating ? "text-yellow-400" : "text-gray-300 dark:text-gray-600"
            }`}
          />
        ))}
      </div>
    );
  };

  const truncateText = (text: string, maxLength: number = 150) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const displayedReviews = staticReviews.slice(0, maxReviews);

  return (
    <section className="py-16 px-4 bg-neutral-50 dark:bg-neutral-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2
            className="text-4xl md:text-5xl font-bold mb-4 text-neutral-900 dark:text-white"
            style={{ color: accentColor }}
          >
            {title}
          </h2>
          <p className="text-lg text-neutral-600 dark:text-neutral-400 mb-8">
            {subtitle}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-4">
            <div className="flex items-center gap-3">
              <span className="text-6xl font-bold text-neutral-900 dark:text-white">
                {averageRating.toFixed(1)}
              </span>
              <div>
                {renderStars(Math.round(averageRating), "large")}
                <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-1">
                  Based on Google reviews
                </p>
              </div>
            </div>

            <a
              href="https://maps.app.goo.gl/N5My64AdjBBPGKXq7"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 font-medium transition-colors group"
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
              </svg>
              <span className="group-hover:underline">View all on Google</span>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {displayedReviews.map((review, index) => (
            <div
              key={index}
              className="bg-white dark:bg-neutral-800 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-transparent hover:border-primary-200 dark:hover:border-primary-800"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={review.profile_photo_url}
                  alt={review.author_name}
                  className="w-12 h-12 rounded-full object-cover ring-2 ring-primary-100 dark:ring-primary-900"
                  onError={(e) => {
                    e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      review.author_name
                    )}&background=random`;
                  }}
                />
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-neutral-900 dark:text-white truncate">
                    {review.author_name}
                  </h4>
                  {/* <p className="text-sm text-neutral-500 dark:text-neutral-400">
                    {review.relative_time_description}
                  </p> */}
                </div>
              </div>

              <div className="mb-3">{renderStars(review.rating)}</div>

              <p className="text-neutral-700 dark:text-neutral-300 text-sm leading-relaxed mb-4">
                {truncateText(review.text, 200)}
              </p>

              <a
                href={review.author_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-sm font-medium transition-colors hover:gap-2"
                style={{ color: accentColor }}
              >
                Read full review
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </a>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://maps.app.goo.gl/N5My64AdjBBPGKXq7"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl font-semibold text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:gap-3 hover:scale-105"
            style={{ backgroundColor: accentColor }}
          >
            <span>Leave us a Review on Google</span>
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviewsDisplay;